module.exports = __webpack_public_path__ + "img/docs.13f67ce5.png";